import { AxiosError, AxiosResponse } from 'axios'
import { useQuery } from 'react-query'
import toast from 'react-hot-toast'
import { ReferralUserConfig } from '@playback-rewards/shared-libraries'

//constants
import QueryKeys from 'constants/queryKeys'
//services
import { getUserReferralConfig } from 'services/referalService'

const useQueryGetUserReferralConfig = () => {
  const { data, isLoading } = useQuery<AxiosResponse<ReferralUserConfig, Error>>(
    QueryKeys.GET_REFERRAL_USER_CONFIG,
    getUserReferralConfig,
    {
      onError: (error) => {
        toast.error(
          ((error as AxiosError)?.response?.data as Error).message || 'Something went wrong!'
        )
      },
    }
  )

  return {
    isLoadingUserReferralConfig: isLoading,
    userReferralConfig: data?.data,
  }
}

export default useQueryGetUserReferralConfig
